import { SET_SIMPLE_VIEW_ATTRIBUTES } from '../actions/types';

export default function simpleViewAttributes(state = null, action) {
	if (!action.error && action.payload !== undefined) {
		switch (action.type) {
			case SET_SIMPLE_VIEW_ATTRIBUTES:
				return action.payload;

			// no default
		}
	}

	return state;
}
